/* eslint-disable no-new */
import './src/styles/global.scss'
import appWrapper from './app-wrapper'
import 'focus-visible'
import UpdateViewportHeight from '~scripts/UpdateViewportHeight'

export const onInitialClientRender = () => {
  const wrapper = document.getElementById('gatsby-focus-wrapper');
  if (wrapper) wrapper.style = undefined;
}

export const wrapRootElement = appWrapper

new UpdateViewportHeight()
